'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import {Scroller} from '@shared/Scroller/Scroller';
import Link from 'next/link';
import {useEffect, useRef} from 'react';

import {MainLanding} from '@strapi/types';

import {getCurrentScrollDepth} from '@web-landing/analytics/helpers/getCurrentScrollDepth';
import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import styles from './KioskPreview.module.scss';

type Props = Pick<MainLanding, 'kioskPreview'>;

export const KioskPreview = ({kioskPreview}: Props) => {
  const kioskRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scrollDepth = getCurrentScrollDepth(kioskRef.current);
    const observer = new IntersectionObserver(
      (elements) => {
        if (elements[0]?.isIntersecting) {
          logTmrEvent('landing.recommendedApps.view', {
            compilation_id: 'landing_app_compilation_UMsKt3',
            compilation_name: 'Киоск / пополняй баланс удобно',
            compilation_num: scrollDepth,
            compilation_type: 'grid',
          });
        }
      },
      {threshold: 0.5},
    );

    kioskRef.current && observer.observe(kioskRef.current);

    return () => {
      kioskRef.current && observer.unobserve(kioskRef.current);
    };
  }, []);

  const onCardClick = () => {
    logTmrEvent('kiosk.appPage.click');
  };
  const onGoAllClick = () => {
    logTmrEvent('landing.kiosk.topUpBalance.click');
  };

  if (!kioskPreview?.links?.length) return null;

  return (
    <div className={styles.wrapper} ref={kioskRef}>
      <h2 className={styles.title}>{kioskPreview.title}</h2>
      <Scroller variant="grid">
        {kioskPreview.links.map(({href, backgroundImage}, index) => (
          <Link
            href={href}
            className={styles.link}
            key={index}
            onClick={onCardClick}
            prefetch={false}
          >
            <ProxyImage imageData={backgroundImage} className={styles.image} />
          </Link>
        ))}
      </Scroller>
      <div className={styles.bottom}>
        <span className={styles.bottom__subtitle}>{kioskPreview.subtitle}</span>
        <Link
          href={'/catalog/kiosk'}
          className={styles.bottom__link}
          prefetch={false}
          onClick={onGoAllClick}
        >
          {kioskPreview.buttonText}
        </Link>
      </div>
    </div>
  );
};
